import styled from 'styled-components'
import { devices } from '../../../utils/screen_sizes'

export const StyledAboutSection = styled.section`
    padding-top: 20rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 12px;
    color: #222;
    background-color: #fff;

    @media ${devices.mobileM} {
        padding-top: 16rem;
    }

    @media ${devices.tablet} {
        padding-top: 28rem;
    }
    @media ${devices.tabletL} {
        padding-top: 32rem;
    }

    @media ${devices.laptop} {
        padding-top: 2rem;
    }
`

export const StyledAboutDescription = styled.div`
    text-align: center;
    color: #444;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding: 0.4rem;

    h3 {
        color: #000;
    }

    hr {
        width: 20vw;
        color: #fff;
    }

    @media ${devices.mobileM} {
        height: 24vh;

        h3 {
            margin-top: auto;
        }
    }
    @media ${devices.tablet} {
        height: auto;
    }
    @media ${devices.laptop} {
        height: auto;
        padding-top: 48px;
    }
    @media ${devices.desktop} {
        padding-top: 12em;
    }
`
export const StyledAboutColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    width: 100vw;
    padding: 16px;
    color: #000;
    background-color: #fff;

    @media ${devices.tablet} {
        grid-template-columns: repeat(3, 1fr);
    }

    @media ${devices.laptop} {
        width: 80vw;
        margin: auto;
        height: 60vh img {
            width: 30%;
        }
    }

    @media ${devices.desktop} {
        grid-template-columns: repeat(3, 1fr);
        width: 60vw;
        height: auto;
        margin: 32px auto;
        padding: 64px;

        img {
            width: 30%;
        }
    }
`
export const AboutCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 8px;
    /* height: 20em; */
    box-sizing: none;
    width: 90vw;

    @media ${devices.mobileM} {
        margin: auto;
        padding: 16px;
    }

    @media ${devices.tablet} {
        width: 100%;
        height: auto;
    }

    @media ${devices.desktop} {
        width: 100%;
    }
`
export const ImageWrapper = styled.img`
    width: 40%;
`
export const StyledAboutTextWrapper = styled.div`
    text-align: center;
    color: #000;
    height: 10rem;

    h4 {
        color: #000;
    }
`
export const StyledPartnersAboutTextWrapper = styled.div`
    text-align: center;
    color: #000;
    height: 6rem;

    h4 {
        color: #000;
    }
`
export const StyledAboutHeading = styled.h4`
    margin: 8px;
`
export const StyledAboutParagraph = styled.p`
    padding-bottom: 32px;

    @media ${devices.laptop} {
        width: 100%;
        height: 100px;
    }

    @media ${devices.desktop} {
        width: 100%;
        height: 100px;
    }
`
// partners

export const StyledPartnersAboutSection = styled.section`
    padding-top: 2rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 12px;
    color: #222;
    background-color: #fff;

    @media ${devices.mobileM} {
        padding-top: 3rem;
    }

    @media ${devices.tablet} {
        padding-top: 8rem;
    }
    @media ${devices.tabletL} {
        padding-top: 13rem;
    }

    @media ${devices.laptop} {
        padding-top: 2rem;
    }
`

export const StyledPartnersAboutDescription = styled.div`
    text-align: center;
    color: #444;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding: 0.4rem;
    @media ${devices.mobileS} {
     margin-top: 16em;
    }
    @media ${devices.laptop} {
     margin-top: 0;
    }

    h3 {
        color: #000;
    }

    hr {
        width: 20vw;
        color: #fff;
    }

    @media ${devices.mobileM} {
        height: 3vh;

        h3 {
            margin-top: auto;
            font-size: 1.3rem;
        }
    }
    @media ${devices.tablet} {
        height: auto;
    }
    @media ${devices.laptop} {
        height: auto;
        padding-top: 48px;
    }
    @media ${devices.desktop} {
        padding-top: 12em;
    }
`
